<template>
  <div class="mt-8 flex flex-col md:flex-row items-center justify-start gap-2">
    <div v-for="file in files" :key="file.name" class="w-full max-w-xs">
      <div
        v-if="isImage(file)"
        class="w-full p-4 bg-white rounded-lg shadow flex flex-col justify-center gap-2 items-center"
      >
        <img :src="file.url" alt="Preview" class="w-64 h-64" />
        <div class="flex items-center justify-between mt-2 w-full">
          <div class="flex-col justify-start items-start gap-1 inline-flex">
            <span ref="nameSpan" class="text-xs">{{
              truncateText(file.name, 20)
            }}</span>
            <span ref="dateSpan" class="text-xs">{{
              truncateText(formattedDate(file.date), 20)
            }}</span>
            <span ref="dateSpan" class="text-xs">{{
              truncateText(username, 20)
            }}</span>
          </div>
          <div class="p-2 rounded-2xl justify-center items-center flex">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              class="rounded-full w-8 h-8"
              @click="() => onDeletePreview(file)"
            ></vs-button>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="w-full p-4 bg-white rounded-lg shadow flex flex-col justify-center gap-2 items-center overflow-x-hidden overflow-y-hidden h-full"
          style="overflow: hidden"
        >
          <iframe
            :src="file.url"
            class="w-64 h-64 overflow-x-hidden overflow-y-hidden"
            style="overflow: hidden"
          ></iframe>
          <div class="flex items-center justify-between mt-2 w-full">
            <div class="flex-col justify-start items-start gap-1 inline-flex">
              <span ref="nameSpan" class="text-xs">{{
                truncateText(file.name, 20)
              }}</span>
              <span ref="dateSpan" class="text-xs">{{
                truncateText(formattedDate(file.date), 20)
              }}</span>
              <span ref="dateSpan" class="text-xs">{{
                truncateText(username, 20)
              }}</span>
            </div>
            <div class="p-2 rounded-2xl justify-center items-center flex">
              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                class="rounded-full w-8 h-8"
                @click="() => onDeletePreview(file)"
              ></vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import jwt from 'jsonwebtoken';

export default {
  name: 'GenericMultiplePreviews',
  props: {
    files: Array,
    onDeletePreview: Function,
  },
  data() {
    return {
      username: String,
    };
  },
  methods: {
    isImage(file) {
      const imageExtensions = ['.jpeg', '.jpg', '.gif', '.png'];
      const lowerCaseName = file.name.toLowerCase();
      return imageExtensions.some((ext) => lowerCaseName.endsWith(ext));
    },
    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
      }
      return text;
    },
    getUserName() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.username = decoded.nome;
      }
    },
  },
  computed: {
    formattedDate() {
      return (date) => moment(date).format('DD/MM/YYYY HH:mm');
    },
  },
  updated() {
    this.$refs.nameSpan.forEach(
      (span) => (span.textContent = this.truncateText(span.textContent, 20)),
    );
    this.$refs.dateSpan.forEach(
      (span) => (span.textContent = this.truncateText(span.textContent, 20)),
    );
  },
  created() {
    this.getUserName();
  },
};
</script>
